import React, { useEffect, useMemo } from "react";
import useModel from "../../hooks/use-model.hook";
import { GroupService } from "../../_service";
import { Avatar } from "../avatar.component";
import IconButton2 from "../icon-button-2-component";
import { Loader } from "../loader.component";
import { Modal } from "../modal.component";

interface MembersListModalProps {
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
  groupId?: string;
  heading: string;
}

export function MembersListModal({
  active,
  setActive,
  groupId,
  heading,
}: MembersListModalProps): JSX.Element {
  const [members, setMembers] = React.useState<any>({});
  const abortController = useMemo(() => new AbortController(), [groupId]);

  const {
    profileModelState: { setShowProfileModel, setIdToViewProfile },
  } = useModel();

  useEffect(() => {
    if (!groupId || !active) return;
    async function fetchMembers(groupId: string) {
      try {
        const members = await GroupService.groupMembers(
          abortController,
          groupId,
          undefined
        );
        setMembers(members);
      } catch (error) {
        console.log(error);
      }
    }
    fetchMembers(groupId);
    return () => {
      abortController.abort();
    };
  }, [abortController, groupId, active]);

  return (
    <>
      <Modal active={active} setActive={setActive} padding={false}>
        <div className="pb-4">
          {/* Heading */}
          <div className="flex items-center justify-between space-x-2 bg-card p-1 pl-4">
            <span className="my-2 font-semibold">{heading}</span>
            <IconButton2
              icon="cross-small"
              solid
              hoverable
              size="2xl"
              onClick={() => {
                setActive(false);
              }}
            />
          </div>
          {/* Body */}
          <div className="my-2 px-4 font-semibold text-secondary-foreground/85">
            <div className="max-h-[50vh] overflow-y-auto">
              {!members?.groupMembers && <Loader />}
              {members?.groupMembers?.map((member: any) => (
                <div key={member.id} className="my-4">
                  <Avatar
                    user={member}
                    extraInfo={member.userId ? "@" + member.userId : ""}
                    className="cursor-pointer"
                    onClick={() => {
                      // open the user page
                      // window.open(
                      //   createUserWallPageRoute(member.id, "activity")
                      // );
                      setShowProfileModel(true);
                      setIdToViewProfile(member.id);
                    }}
                    tag={
                      member.groupRole === "admin" ? (
                        <div className="text-xxs mx-2 rounded bg-primary-foreground px-1 font-semibold text-primary">
                          Admin
                        </div>
                      ) : member.groupRole === "moderator" ? (
                        <div className="text-xxs mx-2 rounded bg-green-50 px-1 font-semibold text-green-500">
                          Moderator
                        </div>
                      ) : member.groupRole === "user" ? (
                        <></>
                      ) : (
                        <></>
                      )
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
